import React from 'react';
import axios from '../services/axios'
const Home = () => {
  const handleClick = async () => {
    await axios.post('/api/test/add', { 
        nom: "nom",
        assistant_id: "assistant_id",
        vs_id: "vs_id"
      });
  };
  return (
    <div className="min-h-screen">
      <h1 className="text-3xl font-bold">Bienvenue</h1>
      <p className="mt-4">Démonstration de l'outil ChatBot IA développé pour la société Phoenix Immo.</p>
      {/* <button onClick={handleClick}>Click me</button> */}
    </div>
  );
};

export default Home; 